import type { Bonus } from '../types/content';

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Diesel Quick Diagnostic Checklists™',
    subtitle: 'Ready-to-use diesel inspection & troubleshooting checklists',
    description:
      'Follow organized checklists for no-starts, hard starting, low power, smoke, boost faults, DPF problems and other common diesel complaints.',
    tagline: 'Check. Follow. Diagnose.',
  },
  {
    number: 2,
    title: 'Diesel DTC & Live Data Field Guide™',
    subtitle: 'A practical DTC & scan-data reference',
    description:
      'Organize trouble-code information and live data to compare commanded and actual values and identify the next logical diagnostic test.',
    tagline: 'Scan. Compare. Test.',
  },
  {
    number: 3,
    title: 'Diesel Test Results & Measurement Worksheets™',
    subtitle: 'Professional ready-to-use diagnostic worksheets',
    description:
      'Record electrical, fuel, injector, boost and aftertreatment measurements and compare your results with the manufacturer’s specifications.',
    tagline: 'Measure. Record. Compare.',
  },
  {
    number: 4,
    title: 'Diesel Symptom-to-Cause Troubleshooting Matrix™',
    subtitle: 'A practical diesel fault-finding reference',
    description:
      'Start with the symptom and see which systems and possible causes should be tested for no-starts, smoke, low power, boost and emissions problems.',
    tagline: 'Find. Follow. Isolate.',
  },
  {
    number: 5,
    title: 'Diesel Diagnostic Job Sheets & Case Report System™',
    subtitle: 'Ready-to-use diagnostic documentation tools',
    description:
      'Document complaints, diagnostic evidence, test results, root causes, repairs and post-repair verification with structured professional job sheets.',
    tagline: 'Diagnose. Verify. Document.',
  },
];
